import axios from "axios";

export const apiNhg = axios.create({
  baseURL: process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION'
    ? process.env.REACT_APP_API_URL_PROD
    : process.env.REACT_APP_API_URL_HML,
  headers: {
    "Content-type": "application/json; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
  },
});

apiNhg.interceptors.request.use((config) => {
  let token = "";
  if (typeof window !== "undefined") {
    const localToken = localStorage.getItem("@token_nhg");
    if (localToken) {
      token = localToken.replaceAll('"', "");
    }

    if (token && config.headers !== undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});


